function CartReload(data) {
  var container = document.getElementById('cart-table')
  var tT = document.getElementById('total-top');
  var c = document.querySelector('.cart-table');
  var tB = document.getElementById('total-bottom');
  const parser = new DOMParser();
  const htmlDocument = parser.parseFromString(data, 'text/html');
  var nTT = htmlDocument.documentElement.querySelector('#total-top');
  var nC = htmlDocument.documentElement.querySelector('.cart-table');
  var nTB = htmlDocument.documentElement.querySelector('#total-bottom');
  tT.replaceWith(nTT);
  c.replaceWith(nC);
  tB.replaceWith(nTB);  
  container.querySelector('.full-form').classList.remove('hidden');
  container.querySelector('.empty-form').classList.add('hidden');
  Quantity(container);
  CartButtons();
}

async function CartChange(triggerEl, container) {
  const header = document.querySelector('header');
  const it = triggerEl.closest('.item');
  const id = it?.getAttribute('data-product-id');
  const qtyInput = it?.querySelector('.item-qty');
  const qtyVal = qtyInput ? Number(qtyInput.value) : 0;

  const aB  = document.getElementById('ajaxBusy');
  const cTa = document.getElementById('cart-table');
  const cC  = document.querySelectorAll('.cartCountSelector');
  const cT  = document.querySelector('.cartTotalSelector');
  const tT  = document.getElementById('total-cart-top');
  const tB  = document.getElementById('total-cart-bottom');
  const tC  = document.getElementById('cart-total');
  const dC  = document.querySelector('.discount-cart');
  const aS  = document.querySelector('.animate-section');
  const cD  = document.getElementById('cart-dropdown');
  const rct = container.getAttribute('data-recent');

  // Toujours afficher le loader au début de l’action
  if (aB) aB.style.display = 'block';

  try {
    // 1) Update quantité
    const res = await fetch(theme.routes_cart_change_url + '.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ quantity: qtyVal, id })
    });
    const j = await res.json();

    // 2) Maj compteurs/totaux si dispo
    cC.forEach(el => { el.textContent = j.item_count; });

    if (header && cT && tT) {
      const total = Shopify.formatMoney(j.total_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
      cT.innerHTML = total;
      tT.innerHTML = total;
    }

    if (j.cart_level_discount_applications && j.cart_level_discount_applications.length > 0 && tC && dC) {
      tC.innerHTML = Shopify.formatMoney(j.items_subtotal_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
      dC.innerHTML = Shopify.formatMoney('-' + j.total_discount, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
    }

    if (tB) {
      tB.innerHTML = Shopify.formatMoney(j.total_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
    }

    // 3) Panier vide ?
    if (j.item_count === 0) {
      ShippingMsg();
      if (cTa) {
        cTa.querySelector('.full-form')?.classList.add('hidden');
        cTa.querySelector('.empty-form')?.classList.remove('hidden');
      }
      if (theme.dropdown === true) {
        const cm = document.querySelector('.cart-count-mobile');
        if (cm) {
          cm.setAttribute('href', theme.routes_cart_url);
          cm.classList.remove('void');
        }
      }
      if (cD) cD.remove();
      if (rct === 'true' && aS) {
        aS.classList.add('go', 'up');
      }
      return; // nothing else to reload
    }

    // 4) Sinon, recharger le HTML de la page panier pour rafraîchir le tableau/les totaux
    try {
      const htmlRes = await fetch(theme.routes_cart_url);
      const data = await htmlRes.text();
      if (qtyVal === 0 && it) it.remove();
      CartReload(data);
    } catch (err) {
      console.error('!: ', err);
    }
  } catch (err) {
    console.error('!: ', err);
  } finally {
    // 🔒 Toujours couper le loader quoi qu’il arrive
    if (aB) aB.style.display = 'none';
  }
}

function CartButtons() {
  var container = document.getElementById('cart-table'),
      qB = container.querySelectorAll('.qtybtn');
  qB.forEach(function(q) {
    if (q.classList.contains('icon-plus')) {
      var qF = q.closest('.quantity.form'),
          vV = qF.querySelector('.item-qty').value,
          vM = qF.querySelector('.item-qty').getAttribute('max');
    };
    setTimeout(function () {
      q.onclick = function(ev){
        if (vM && vM == vV) {
          return;
        }
        CartChange(q,container);
      }
    }, 1);
  })  
  var qI = container.querySelectorAll('.item-qty');
  qI.forEach(function(q) {
    let timeout;
    var vV = q.value,
        vM = q.getAttribute('max');
    q.addEventListener('keyup', function (e) {
      if (e.key == 'Tab' || e.key == 'Shift') return;
      var nV = q.value;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        if (vM && nV == vV && vM == nV) {
          return;
        }
        CartChange(q,container);
      }, 750);
    });
  });  
}

theme.CartPage = (function() {
  function CartPage(container) {
    var sectionId = container.getAttribute('data-section-id');
    var chk = container.getAttribute('data-check');
    var rct = container.getAttribute('data-recent');
    var rV = document.getElementById('recently-viewed');
    var rVP = document.getElementById('recently-viewed-placeholder');
    theme.cart = true;
    Quantity(container);
    if(chk == 'true'){      
      var nC = container.querySelector('[name="checkout"]');
      document.getElementById('cart-terms').onclick = function(ev){
        if (this.checked == true) {
          nC.classList.remove('outline');
          nC.removeAttribute('disabled');
          nC.setAttribute('aria-label', theme.language.cart_general_checkout);
          nC.value = theme.language.cart_general_checkout;
          nC.textContent = theme.language.cart_general_checkout;
        } else {
          nC.classList.add('outline');
          nC.setAttribute('disabled', true);
          nC.setAttribute('aria-label', theme.language.cart_general_agree);
          nC.value = theme.language.cart_general_agree;
          nC.textContent = theme.language.cart_general_agree;
        }
      };
    };
    CartButtons(container);
    if(rct == 'true'){
      function gPD (){
        const pD = JSON.parse(localStorage.getItem('rVP'));
        const rVH = []
        if (pD) {
          rV.classList.remove('hidden');          
          pD.forEach(function(item,i){
            rVH.push('id:' + item.pID);
          });
          const rB = rVH.join('%20OR%20');
          fetch(theme.routes_search_url + '?section_id=recently-viewed&q=' + rB + '&type=product')
          .then(response => response.text())
          .then(data => {   
            const parser = new DOMParser();
            const htmlDocument = parser.parseFromString(data, 'text/html');
            var rVD = document.querySelector('.recently-viewed');
            var cP = htmlDocument.documentElement.querySelector('.collection-products');
            rVP.remove();
            rVD.appendChild(cP);
            if (theme.settings.quickView) {
              Quick();
            };
            if (theme.settings.compare) {
              CompareProducts();
            };
            Swatches(container);
            if (theme.settings.cart) {
              var sI = cP.getAttribute('data-section-id');
              Cart(container,sI);
            }
          }).catch(function (err) {
            console.log('!: ' + err);
          });
        }
      }    
      gPD();
    };
    if (Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  }
  return CartPage;
})();